const STORAGE_KEY = "femtyz_grocery_product_views";

export function normalizeGroceryProductPlatform(platform) {
  const p = String(platform || "").trim().toLowerCase();
  if (!p) return "";
  if (p.includes("tesco")) return "tesco";
  if (p.includes("asda")) return "asda";
  if (p.includes("morris")) return "morrison";
  if (p.includes("sains")) return "sainsbury";
  if (p === "tesco" || p === "asda" || p === "morrison" || p === "sainsbury") return p;
  return "";
}

function storageKey(listId, productId) {
  return `${String(listId)}:${String(productId)}`;
}

export function rememberGroceryProductView({ listId, productId, view, platform }) {
  if (!listId || !productId || !view) return;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const map = raw ? JSON.parse(raw) : {};
    map[storageKey(listId, productId)] = {
      view,
      platform: normalizeGroceryProductPlatform(platform) || undefined,
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // ignore
  }
}

export function getGroceryProductView({ listId, productId }) {
  if (!listId || !productId) return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const map = raw ? JSON.parse(raw) : {};
    return map[storageKey(listId, productId)] || null;
  } catch {
    return null;
  }
}

export function getGroceryProductDetailPath({ listId, productId, platform }) {
  const id = String(productId || "").trim();
  if (!id) return null;

  const stored = getGroceryProductView({ listId, productId: id });
  const normalizedPlatform = normalizeGroceryProductPlatform(stored?.platform || platform);
  const view = stored?.view || (normalizedPlatform ? "single" : "compare");

  if (view === "single" && normalizedPlatform) {
    return `/product-store/${encodeURIComponent(normalizedPlatform)}/${encodeURIComponent(id)}`;
  }

  return `/product/${encodeURIComponent(id)}`;
}
